"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _components = require("../../components");
var _DatePickerFooter = _interopRequireDefault(require("../../components/shared/DatePickerFooter"));
var _inputDate = require("./inputDate.style");
var _dateTime = require("../../utils/dateTime");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const InputDate = /*#__PURE__*/(0, _react.forwardRef)((_a, ref) => {
  var {
      className = 'inputDate',
      children,
      dateFormat = 'dd/MM/yyyy',
      disabled,
      fit = 'medium',
      footerType,
      error,
      errorMessage,
      hint,
      label,
      placeholder,
      popperProps,
      prefix,
      icon = 'calendar',
      iconPosition = 'right',
      id,
      max,
      min,
      name,
      readOnly = false,
      required,
      selectsRange,
      suffix,
      tooltipDescription,
      width,
      value,
      startDate,
      endDate,
      variant = 'default',
      showOptional,
      autocomplete = 'off',
      inline = false,
      onBlur,
      onChange,
      onRangeChange,
      onSave,
      onFocus
    } = _a,
    rest = __rest(_a, ["className", "children", "dateFormat", "disabled", "fit", "footerType", "error", "errorMessage", "hint", "label", "placeholder", "popperProps", "prefix", "icon", "iconPosition", "id", "max", "min", "name", "readOnly", "required", "selectsRange", "suffix", "tooltipDescription", "width", "value", "startDate", "endDate", "variant", "showOptional", "autocomplete", "inline", "onBlur", "onChange", "onRangeChange", "onSave", "onFocus"]);
  const months = (0, _dateTime.allMonths)();
  const [startDateState, setStartDate] = (0, _react.useState)(null);
  const [endDateState, setEndDate] = (0, _react.useState)(null);
  const [showMonths, setShowMonths] = (0, _react.useState)(undefined);
  const [headerMonth, setHeaderMonth] = (0, _react.useState)();
  const [showYears, setShowYears] = (0, _react.useState)(undefined);
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [minDate, setMinDate] = (0, _react.useState)(null);
  const [maxDate, setMaxDate] = (0, _react.useState)(null);
  const [selectedMonth, setSelectedMonth] = (0, _react.useState)();
  const [selectedYear, setSelectedYear] = (0, _react.useState)();
  const [placeholderText, setPlaceholderText] = (0, _react.useState)(placeholder || '');
  const textInput = (0, _react.useRef)(null);
  const mainDivRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (startDate) {
      setStartDate(new Date(startDate));
    }
    if (endDate) {
      setEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);
  (0, _react.useMemo)(() => {
    if (!placeholder) {
      if (dateFormat.length === 10) {
        const placeholder = selectsRange ? "".concat(dateFormat, " - ").concat(dateFormat) : dateFormat;
        setPlaceholderText(placeholder);
      }
    } else {
      setPlaceholderText(placeholder);
    }
  }, [dateFormat, placeholder]);
  (0, _react.useMemo)(() => {
    if (selectedYear && startDateState) {
      setStartDate((0, _dateTime.setYear)(startDateState, selectedYear));
    }
    if (selectedMonth && startDateState) {
      setStartDate((0, _dateTime.setMonth)(startDateState, selectedMonth));
    }
  }, [selectedMonth, selectedYear]);
  (0, _react.useMemo)(() => {
    if (min) {
      setMinDate((0, _dateTime.getFormattedDate)(min.toLocaleString(), dateFormat));
    }
    if (max) {
      setMaxDate((0, _dateTime.getFormattedDate)(max.toLocaleString(), dateFormat));
    }
    if (value) {
      typeof value === 'string' ? setStartDate((0, _dateTime.getFormattedDate)(value, dateFormat)) : setStartDate(value);
    } else {
      setStartDate(null); // TODO: Once design is ready implement clear date functionality with no footer.
      setHeaderMonth(null);
    }
  }, [min, max, value]);
  const handleOnBlur = e => {
    if (isOpen) {
      setIsOpen(!isOpen);
    }
    if (onBlur) {
      onBlur(e);
    }
  };
  const handleOnFocus = e => {
    setIsOpen(true);
    if (onFocus) {
      onFocus(e);
    }
  };
  const handleOnClickOutside = () => {
    showMonths && setShowMonths(!showMonths);
    showYears && setShowYears(!showYears);
    setIsOpen(false);
  };
  const handleChange = (date, e) => {
    setIsOpen(true);
    if (showYears) {
      if (startDateState) {
        setSelectedYear(Number((0, _dateTime.getYear)(date)));
      } else {
        setStartDate((0, _dateTime.setYear)(date, Number((0, _dateTime.getYear)(date))));
      }
      setShowYears(false);
      setShowMonths(true);
    } else if (showMonths) {
      if (startDateState) {
        setSelectedMonth(Number((0, _dateTime.getMonth)(date)));
      } else {
        setStartDate((0, _dateTime.setMonth)(date, Number((0, _dateTime.getMonth)(date))));
      }
      setHeaderMonth(months[(0, _dateTime.getMonth)(date)]);
      setShowMonths(false);
    } else {
      setStartDate(date);
      setStartDate(date => {
        if (selectedMonth || selectedYear) {
          if (startDateState) {
            const updatedDate = startDateState.setDate(Number((0, _dateTime.getDate)(date)));
            setStartDate(new Date(updatedDate));
            setHeaderMonth(months[(0, _dateTime.getMonth)(startDateState)]);
            onChange(startDateState, e);
            setSelectedMonth(0);
            setSelectedYear(0);
          }
        } else {
          setHeaderMonth(months[(0, _dateTime.getMonth)(date)]);
          onChange(date, e);
        }
        return date;
      });
      setIsOpen(false);
    }
  };
  const onDateRangeChange = dates => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (onRangeChange) {
      onRangeChange(dates);
    }
    if (start && end) {
      setIsOpen(false);
    }
  };
  const handleCancel = () => {
    setStartDate(value ? new Date(value) : null);
    setIsOpen(false);
  };
  const handleReset = () => {
    if (value !== null && onSave) {
      onSave(null);
    }
    setStartDate(null);
  };
  const handleSave = () => {
    if (onSave) {
      onSave(startDateState);
      setIsOpen(false);
    }
  };
  const onClickMonth = () => {
    setShowMonths(!showMonths);
    setIsOpen(true);
  };
  const onClickYear = () => {
    setShowYears(!showYears);
    setIsOpen(true);
  };
  const onCalIconClick = e => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    setIsOpen(!isOpen);
    if (textInput && textInput.current) {
      textInput.current.setFocus(true);
    }
  };
  const renderCustomInput = (0, _jsxRuntime.jsx)(_components.Input, (0, _extends2["default"])({
    className: className,
    disabled: disabled,
    error: error,
    errorMessage: errorMessage,
    fit: fit,
    hint: hint,
    icon: icon,
    iconPosition: iconPosition,
    id: id,
    label: label,
    name: name,
    placeholder: placeholderText,
    prefix: prefix,
    required: required,
    readOnly: readOnly,
    showOptional: showOptional,
    suffix: suffix,
    tooltipDescription: tooltipDescription,
    value: (startDateState === null || startDateState === void 0 ? void 0 : startDateState.toString()) || '',
    variant: variant,
    width: width,
    autocomplete: autocomplete
  }, rest, {
    onIconClick: e => onCalIconClick(e)
  }));
  const renderCustomHeader = _ref => {
    let {
      changeMonth,
      date,
      decreaseMonth,
      decreaseYear,
      increaseMonth,
      increaseYear
    } = _ref;
    const headerContent = () => {
      if (showMonths) {
        return (0, _jsxRuntime.jsx)(_inputDate.Components.HeaderButton, (0, _extends2["default"])({
          onClick: () => {
            changeMonth((0, _dateTime.getMonth)(date));
            onClickMonth();
          }
        }, {
          children: months[(0, _dateTime.getMonth)(date)]
        }));
      } else if (showYears) {
        return (0, _jsxRuntime.jsx)(_inputDate.Components.HeaderButton, (0, _extends2["default"])({
          onClick: () => {
            onClickYear();
          }
        }, {
          children: (0, _dateTime.getYearsPickerRangeStart)((0, _dateTime.getYear)(date))
        }));
      }
      return (0, _jsxRuntime.jsxs)(_components.Box, (0, _extends2["default"])({
        display: "flex"
      }, {
        children: [(0, _jsxRuntime.jsx)(_inputDate.Components.HeaderButton, (0, _extends2["default"])({
          value: months[(0, _dateTime.getMonth)(date)],
          onClick: () => {
            changeMonth((0, _dateTime.getMonth)(date));
            onClickMonth();
          }
        }, {
          children: headerMonth || months[(0, _dateTime.getMonth)(date)]
        })), (0, _jsxRuntime.jsx)(_inputDate.Components.HeaderButton, (0, _extends2["default"])({
          value: (0, _dateTime.getYear)(date),
          onClick: onClickYear
        }, {
          children: (0, _dateTime.getYear)(date)
        }))]
      }));
    };
    return (0, _jsxRuntime.jsxs)(_components.Box, (0, _extends2["default"])({
      display: "flex",
      justifyContent: "space-between",
      px: 8
    }, {
      children: [!showMonths && (0, _jsxRuntime.jsx)(_inputDate.Components.HeaderButtonIcon, {
        children: (0, _jsxRuntime.jsx)(_components.Button, {
          icon: "double-chevron-left",
          onClick: decreaseYear,
          fit: "small",
          variant: "plain"
        })
      }), !showYears && (0, _jsxRuntime.jsx)(_inputDate.Components.HeaderButtonIcon, {
        children: (0, _jsxRuntime.jsx)(_components.Button, {
          icon: "chevron-left",
          onClick: () => {
            setHeaderMonth(null);
            decreaseMonth();
          },
          fit: "small",
          variant: "plain"
        })
      }), (0, _jsxRuntime.jsx)(_components.Box, (0, _extends2["default"])({
        display: "flex"
      }, {
        children: headerContent()
      })), !showYears && (0, _jsxRuntime.jsx)(_inputDate.Components.HeaderButtonIcon, {
        children: (0, _jsxRuntime.jsx)(_components.Button, {
          icon: "chevron-right",
          onClick: () => {
            setHeaderMonth(null);
            increaseMonth();
          },
          fit: "small",
          variant: "plain"
        })
      }), !showMonths && (0, _jsxRuntime.jsx)(_inputDate.Components.HeaderButtonIcon, {
        children: (0, _jsxRuntime.jsx)(_components.Button, {
          icon: "double-chevron-right",
          onClick: increaseYear,
          fit: "small",
          variant: "plain"
        })
      })]
    }));
  };
  return (0, _jsxRuntime.jsx)(_inputDate.Components.RefWrapper, (0, _extends2["default"])({
    className: className,
    ref: ref
  }, {
    children: (0, _jsxRuntime.jsx)(_inputDate.Components.Wrapper, (0, _extends2["default"])({
      ref: mainDivRef,
      error: error,
      fit: fit,
      variant: variant,
      "data-testid": "date-picker",
      inline: inline
    }, {
      children: (0, _jsxRuntime.jsx)(_inputDate.Components.InputWrapper, (0, _extends2["default"])({
        error: error,
        fit: fit,
        variant: variant
      }, {
        children: selectsRange ? (0, _jsxRuntime.jsx)(_reactDatepicker["default"], (0, _extends2["default"])({
          dateFormat: dateFormat,
          disabled: disabled,
          maxDate: maxDate || undefined,
          minDate: minDate || undefined,
          popperProps: popperProps,
          placeholderText: placeholderText,
          onChange: onDateRangeChange,
          customInput: renderCustomInput,
          open: isOpen && !readOnly,
          readOnly: readOnly,
          ref: textInput,
          id: id,
          name: name,
          startDate: startDateState,
          endDate: endDateState,
          required: required,
          selectsRange: true,
          selected: startDateState,
          showMonthYearPicker: showMonths,
          showYearPicker: showYears,
          shouldCloseOnSelect: false,
          autoComplete: autocomplete,
          onBlur: onBlur,
          onFocus: e => handleOnFocus(e),
          onClickOutside: () => handleOnClickOutside(),
          inline: inline
        }, {
          children: footerType && (0, _jsxRuntime.jsx)(_DatePickerFooter["default"], {
            footerType: footerType,
            customFooter: children,
            onCancel: handleCancel,
            onReset: handleReset,
            onSave: handleSave
          })
        })) : (0, _jsxRuntime.jsx)(_reactDatepicker["default"], (0, _extends2["default"])({
          dateFormat: dateFormat,
          disabled: disabled,
          maxDate: maxDate || undefined,
          minDate: minDate || undefined,
          open: isOpen && !readOnly,
          required: required,
          customInput: renderCustomInput,
          placeholderText: placeholderText,
          readOnly: readOnly,
          ref: textInput,
          id: id,
          name: name,
          renderCustomHeader: renderCustomHeader,
          selected: startDateState,
          showMonthYearPicker: showMonths,
          showYearPicker: showYears,
          shouldCloseOnSelect: false,
          selectsEnd: true,
          onChange: (date, e) => handleChange(date, e),
          popperProps: popperProps,
          autoComplete: autocomplete,
          onBlur: e => handleOnBlur(e),
          onFocus: e => handleOnFocus(e),
          onClickOutside: () => handleOnClickOutside(),
          inline: inline
        }, {
          children: footerType && (0, _jsxRuntime.jsx)(_DatePickerFooter["default"], {
            footerType: footerType,
            customFooter: children,
            onCancel: handleCancel,
            onReset: handleReset,
            onSave: handleSave
          })
        }))
      }))
    }))
  }));
});
var _default = exports["default"] = InputDate;